import React, { useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { PostmarkSuccess, Field } from "./FormBits";
import { TALENT_OPTIONS } from "../../lib/data";

export const TalentForm = () => {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [talents, setTalents] = useState([]);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const toggle = (t) => setTalents((s) => (s.includes(t) ? s.filter((x) => x !== t) : [...s, t]));

  const submit = async (e) => {
    e.preventDefault();
    if (talents.length === 0) return toast.error("Please pick at least one talent or interest");
    setBusy(true);
    try {
      await api.post("/forms/talent", { ...form, talents });
      setDone(true);
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  if (done)
    return (
      <PostmarkSuccess
        title="Your Talent Is In The Spotlight!"
        message="Thanks for signing up to perform or get involved at Pak Fest 2026. Our team will reach out about auditions, rehearsals and next steps."
        onReset={() => { setForm({ name: "", email: "", phone: "", message: "" }); setTalents([]); setDone(false); }}
      />
    );

  return (
    <form onSubmit={submit} className="max-w-2xl mx-auto space-y-6" data-testid="talent-form">
      <p className="text-forest-light text-center text-[0.95rem]">
        Sing, dance, play, host, or help plan — got a talent or want to be part of the show?
        Tell us how you'd like to be involved (including our kids' national anthem choir).
      </p>

      <div className="grid md:grid-cols-2 gap-6">
        <Field label="Full Name" required>
          <input className="vintage-input" required value={form.name} onChange={set("name")} data-testid="t-name" />
        </Field>
        <Field label="Email" required>
          <input type="email" className="vintage-input" required value={form.email} onChange={set("email")} data-testid="t-email" />
        </Field>
      </div>

      <Field label="Phone (optional)">
        <input className="vintage-input" value={form.phone} onChange={set("phone")} data-testid="t-phone" />
      </Field>

      <Field label="I'd like to be involved as / with" required>
        <div className="grid sm:grid-cols-2 gap-3 mt-1">
          {TALENT_OPTIONS.map((t) => (
            <label
              key={t}
              className={`flex items-center gap-2 border-2 px-3 py-2 cursor-pointer text-sm transition-colors ${talents.includes(t) ? "border-rust bg-rust/10" : "border-forest/40"}`}
              data-testid={`t-option-${t.replace(/[^a-z]/gi, "").toLowerCase()}`}
            >
              <input type="checkbox" className="accent-rust w-4 h-4" checked={talents.includes(t)} onChange={() => toggle(t)} />
              {t}
            </label>
          ))}
        </div>
      </Field>

      <Field label="Tell us about your talent (optional)">
        <textarea className="vintage-input min-h-[80px] resize-y" value={form.message} onChange={set("message")} placeholder="e.g. I sing classical & folk, or I can choreograph a group dance…" data-testid="t-message" />
      </Field>

      <button type="submit" disabled={busy} className="btn-rust w-full py-4 text-base disabled:opacity-60" data-testid="t-submit">
        {busy ? "Submitting…" : "Sign Up To Perform"}
      </button>
    </form>
  );
};
